import { Schema } from 'mongoose';

/* see : https://help.shopify.com/en/api/reference/discounts/pricerule */
const priceRule = new Schema({
  oncePerCustomer: {
    type: Boolean,
    required: true,
  },
  startAt: {
    type: Date,
    required: true,
  },
  endAt: {
    type: Date,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  usageLimit: {
    type: String,
    required: true,
  },
  value: {
    type: Number,
    required: true,
  },
  valueType: {
    type: String,
    required: true,
  },
  automatic: {
    type: Boolean,
    required: true,
  },
  prerequisite: {
    type: String,
    required: true,
  },
});

export default priceRule;
